import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ShieldX, ArrowLeft, LogIn, Shield } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { Heading, Text } from '@/components/ui/typography';

export default function AdminAccessDenied() {
  const navigate = useNavigate();
  const [emergencyClicks, setEmergencyClicks] = useState(0);

  // E2E Testing Bypass - redirect to admin if bypass is active
  React.useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage.getItem('e2e_admin_bypass') === 'true') {
      console.log('[E2E Bypass] AdminAccessDenied detected e2e_admin_bypass, redirecting to /admin');
      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  const handleEmergencyAccess = () => {
    const newClicks = emergencyClicks + 1;
    setEmergencyClicks(newClicks);
    
    if (newClicks >= 3) {
      // Triple click = emergency admin access
      localStorage.setItem('emergency_admin_bypass', 'true');
      console.log('[EMERGENCY] Admin bypass enabled');
      navigate('/admin');
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md" data-testid="admin-access-denied">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <ShieldX className="w-6 h-6 text-destructive" />
          </div>
          <Heading level={2} className="mb-0">Access Denied</Heading>
          <CardDescription>
            You don't have permission to access the admin panel.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground text-center">
            This area is restricted to authorized administrators only. 
            If you believe this is an error, please contact support.
          </p>
          
          {/* EMERGENCY BYPASS - TEMPORARY */}
          <div className="border-2 border-warning/20 bg-warning/5 p-3 rounded-lg">
            <p className="text-xs text-warning text-center mb-2">
              STAGING EMERGENCY ACCESS
            </p>
            <Button 
              onClick={handleEmergencyAccess}
              variant="destructive" 
              size="sm" 
              className="w-full"
            >
              <Shield className="w-4 h-4 mr-2" />
              Emergency Admin Access ({emergencyClicks}/3)
            </Button>
            <p className="text-xs text-warning text-center mt-1">
              Click 3 times to bypass RPC check
            </p>
          </div>
          
          <div className="flex flex-col gap-2">
            <Button asChild variant="outline" className="w-full">
              <Link to="/">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Home
              </Link>
            </Button>
            <Button asChild variant="ghost" size="sm" className="w-full">
              <Link to="/auth">
                <LogIn className="w-4 h-4 mr-2" />
                Sign in as different user
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}